export default __webpack_public_path__ + "static/media/norecipe.3a5156a0.svg";